<template>
  <modal
    name="cupomEdit"
    height="auto"
    width="900"
    :scrollable="true"
    @before-open="beforeOpen()"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="bdti-alert bdti-alert-danger" v-if="error && error.message">
          {{ error.message }}
        </div>

        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab :title="`Criar ${descSingular}`">
            <CAlert show color="warning" class="mb-2" style="font-size: 13px;">
              ATENÇÃO: Mudamos o formato de desconto aplicado de cupons. Todo
              cupom transmitido através das nossas plataformas será através da
              geração de um crédito ao cliente para atender as normas da
              integradora de seu ERP.
            </CAlert>

            <!-- Informações básicas -->
            <CRow>
              <CCol md="4">
                <div class="form-group">
                  <label class="field-label">Código <span class="text-danger">*</span></label>
                  <input
                    class="form-control form-control-sm"
                    maxlength="15"
                    v-model="item.codigo"
                    placeholder="Ex: PROMO2026"
                  />
                  <div class="message">
                    {{ validation.firstError("item.codigo") }}
                  </div>
                </div>
              </CCol>
              <CCol md="4">
                <div class="form-group">
                  <label class="field-label">Tipo de desconto</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="item.tipoDesconto"
                    v-on:change="resetTipointegracao"
                  >
                    <option value="F">Valor Fixo</option>
                    <option value="P">Valor Percentual</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4">
                <div class="form-group" v-if="item.tipoDesconto === 'F'">
                  <label class="field-label">Valor do desconto</label>
                  <money
                    class="form-control form-control-sm"
                    v-model="item.valor"
                    v-bind="monetary"
                  />
                  <div class="message">
                    {{ validation.firstError("item.valor") }}
                  </div>
                </div>
                <div class="form-group" v-if="item.tipoDesconto === 'P'">
                  <label class="field-label">Percentual do desconto</label>
                  <vue-numeric
                    currency="%"
                    currency-symbol-position="suffix"
                    v-bind:max="100"
                    v-bind:precision="2"
                    v-model="item.valor"
                    class="form-control form-control-sm"
                  />
                  <div class="message">
                    {{ validation.firstError("item.valor") }}
                  </div>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <div class="form-group">
                  <label class="field-label">Data de início</label>
                  <datetime
                    input-class="form-control form-control-sm"
                    type="datetime"
                    v-model="item.dataInicio"
                    :max-datetime="item.dataFim"
                    :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
                    value-zone="local"
                  />
                  <div class="message">
                    {{ validation.firstError("item.dataInicio") }}
                  </div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group">
                  <label class="field-label">Data de término</label>
                  <datetime
                    :disabled="item.dataInicio === null"
                    input-class="form-control form-control-sm"
                    type="datetime"
                    :min-datetime="item.dataInicio"
                    v-model="item.dataFim"
                    :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
                    value-zone="local"
                  />
                  <div class="message">
                    {{ validation.firstError("item.dataFim") }}
                  </div>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="12">
                <div class="form-group">
                  <label class="field-label">Orientações ao cliente <span class="text-danger">*</span></label>
                  <textarea
                    rows="2"
                    class="form-control form-control-sm"
                    v-model="item.orientacao"
                    placeholder="Descreva as orientações para o cliente..."
                  />
                  <div class="message">
                    {{ validation.firstError("item.orientacao") }}
                  </div>
                </div>
              </CCol>
            </CRow>

            <!-- Canais disponíveis -->
            <div class="section-label">Canais disponíveis</div>
            <div class="canais-grid">
              <div
                class="canal-card"
                :class="{ active: item.B2B }"
                @click="item.B2B = !item.B2B"
              >
                <div class="canal-card__icon"><fa-icon icon="shopping-basket" /></div>
                <div class="canal-card__label">B2B</div>
                <div class="canal-card__check" :class="{ checked: item.B2B }">
                  <CIcon v-if="item.B2B" name="cil-check" size="sm" />
                </div>
              </div>
              <div
                class="canal-card"
                :class="{ active: item.CALLCENTER }"
                @click="item.CALLCENTER = !item.CALLCENTER"
              >
                <div class="canal-card__icon"><fa-icon icon="headset" /></div>
                <div class="canal-card__label">Callcenter</div>
                <div class="canal-card__check" :class="{ checked: item.CALLCENTER }">
                  <CIcon v-if="item.CALLCENTER" name="cil-check" size="sm" />
                </div>
              </div>
              <div
                class="canal-card"
                :class="{ active: item.FORCA_VENDAS }"
                @click="item.FORCA_VENDAS = !item.FORCA_VENDAS"
              >
                <div class="canal-card__icon"><fa-icon icon="user-tie" /></div>
                <div class="canal-card__label">Força de Vendas</div>
                <div class="canal-card__check" :class="{ checked: item.FORCA_VENDAS }">
                  <CIcon v-if="item.FORCA_VENDAS" name="cil-check" size="sm" />
                </div>
              </div>
            </div>

            <!-- Configurações -->
            <div class="section-label">Configurações</div>
            <div class="toggles-card">
              <div class="toggle-row">
                <span class="toggle-row__label">Aplicar desconto sobre</span>
                <select
                  class="form-control form-control-sm toggle-row__select"
                  v-model="item.aplica_sobre_imposto"
                >
                  <option value="0">Preço sem imposto</option>
                  <option value="1">Preço com imposto</option>
                </select>
              </div>
              <div class="toggle-row">
                <span class="toggle-row__label">Aplicar desconto em</span>
                <select class="form-control form-control-sm toggle-row__select" v-model="item.tipoRegra">
                  <option
                    v-if="item.tipoDesconto === 'P' && !hasRuleProdutos"
                    value="D"
                  >
                    Produtos das regras de dimensões
                  </option>
                  <option
                    v-if="item.tipoDesconto === 'P' && hasRuleProdutos"
                    value="PR"
                  >
                    Produtos das regras de produtos
                  </option>
                  <option value="P">Total do pedido</option>
                </select>
              </div>
              <div class="toggle-row">
                <span class="toggle-row__label">Validar valor mínimo plano</span>
                <label class="toggle-switch">
                  <input type="checkbox" :checked="item.valida_valor_minimo_plano == 1" @change="item.valida_valor_minimo_plano = $event.target.checked ? '1' : '0'" />
                  <span class="toggle-slider"></span>
                  <span class="toggle-text">{{ item.valida_valor_minimo_plano == 1 ? 'Sim' : 'Não' }}</span>
                </label>
              </div>
              <div class="toggle-row">
                <span class="toggle-row__label">Considera promoção</span>
                <label class="toggle-switch">
                  <input type="checkbox" :checked="item.aplica_sobre_promocao == 1" @change="item.aplica_sobre_promocao = $event.target.checked ? '1' : '0'" />
                  <span class="toggle-slider"></span>
                  <span class="toggle-text">{{ item.aplica_sobre_promocao == 1 ? 'Sim' : 'Não' }}</span>
                </label>
              </div>
              <div class="toggle-row">
                <span class="toggle-row__label">
                  Limite por cliente
                  <span class="toggle-row__validation" v-if="validation.firstError('item.limiteUsos')">
                    {{ validation.firstError("item.limiteUsos") }}
                  </span>
                </span>
                <the-mask
                  mask="###"
                  class="form-control form-control-sm toggle-row__input"
                  v-model="item.limiteUsos"
                  placeholder="Ex: 1"
                />
              </div>
              <div class="toggle-row">
                <span class="toggle-row__label">
                  Limite geral
                  <span class="toggle-row__validation" v-if="validation.firstError('item.limiteusos_geral')">
                    {{ validation.firstError("item.limiteusos_geral") }}
                  </span>
                </span>
                <the-mask
                  mask="###"
                  class="form-control form-control-sm toggle-row__input"
                  v-model="item.limiteusos_geral"
                  placeholder="Sem limite"
                />
              </div>
              <div class="toggle-row">
                <span class="toggle-row__label">
                  Valor máximo desconto
                  <span class="toggle-row__validation" v-if="validation.firstError('item.valor_maximo_permitido')">
                    {{ validation.firstError("item.valor_maximo_permitido") }}
                  </span>
                </span>
                <div class="toggle-row__money-group">
                  <label class="toggle-inline">
                    <input type="checkbox" v-model="isChecked" />
                  </label>
                  <money
                    :disabled="!isChecked"
                    class="form-control form-control-sm toggle-row__input"
                    v-model="item.valor_maximo_permitido"
                    v-bind="monetary"
                  />
                </div>
              </div>
            </div>
            <div class="section-label">Criar nova regra</div>
            <div class="new-rule-card">
              <CRow class="align-items-end">
                <CCol md="3">
                  <div class="form-group mb-0">
                    <label class="field-label">Regra por</label>
                    <select
                      class="form-control form-control-sm"
                      :disabled="hasRuleProdutos"
                      v-model="newRuleForm.type"
                      v-on:change="resetNewRule"
                    >
                      <option v-if="!hasRuleProdutos" value="D">Dimensão</option>
                      <option v-if="!hasRulePedido && !hasRuleProdutos" value="P">
                        Pedido
                      </option>
                      <option
                        v-if="
                          !hasRulePedido && !hasRuleProdutos && !hasRuleDimensoes
                        "
                        value="PR"
                      >
                        Produto
                      </option>
                    </select>
                  </div>
                </CCol>
                <template v-if="newRuleForm.type === 'D' && !hasRuleProdutos">
                  <CCol md="3">
                    <div class="form-group mb-0">
                      <label class="field-label">Quando</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="newRuleForm.dim"
                        v-on:change="changeDimensao"
                      >
                        <option v-for="(dim, index) in dimensoes" :value="index">
                          {{ dim.label }}
                        </option>
                      </select>
                    </div>
                  </CCol>
                  <CCol md="3">
                    <div class="form-group mb-0">
                      <label class="field-label">Igual a</label>
                      <select class="form-control form-control-sm" v-model="newRule.dimensao.id">
                        <option
                          v-for="(item, index) in getDimensoesItens"
                          :key="index"
                          :value="item.id"
                          :selected="index === 0"
                        >
                          {{ item.desc }}
                        </option>
                      </select>
                    </div>
                  </CCol>
                </template>
                <CCol md="3" v-if="!hasRuleProdutos">
                  <div class="form-group mb-0">
                    <label class="field-label">{{ newRuleForm.type === 'PR' ? 'Valor mínimo do pedido' : 'Valor mínimo' }}</label>
                    <div class="input-group input-group-sm">
                      <money
                        class="form-control form-control-sm"
                        v-model="newRule.valorMinimo"
                        v-bind="monetary"
                      />
                      <CButton
                        color="primary"
                        size="sm"
                        class="input-group-addon-right"
                        title="Adicionar regra"
                        :disabled="isValorMinimoZero"
                        @click="addRule(newRuleForm.type)"
                      >
                        <fa-icon icon="plus" />
                      </CButton>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CAlert
                v-if="newRuleForm.type === 'D' && !hasRuleProdutos"
                show
                color="warning"
                class="rule-alert"
              >
                <b>AVISO:</b> Para que o cupom seja considerado válido no
                momento da aplicação, o pedido deve incluir produtos que atendam
                a todas as dimensões exigidas na seção abaixo.
              </CAlert>
              <CAlert
                v-if="newRuleForm.type === 'P'"
                show
                color="warning"
                class="rule-alert"
              >
                <b>AVISO:</b> Para que o cupom seja considerado válido no
                momento da utilização, o pedido deve atender ao valor mínimo
                exigido conforme a regra descrita na seção abaixo.
              </CAlert>
              <CAlert
                v-if="newRuleForm.type === 'PR' || hasRuleProdutos"
                show
                color="warning"
                class="rule-alert"
              >
                <b>AVISO:</b> Para que o cupom seja considerado válido no
                momento da aplicação, o pedido deve incluir pelo menos um dos
                produtos exigidos na seção abaixo.
              </CAlert>
            </div>
            <div class="section-label">
              Regras para ativação
              <small class="validation-error" v-if="validation.firstError('item.regras')">
                {{ validation.firstError("item.regras") }}
              </small>
            </div>
            <EmptyState
              v-if="!item.regras.length"
              icon="clipboard-list"
              title="Nenhuma regra definida"
              description="Adicione regras usando o formulário acima"
            />
            <div v-else class="rules-table-wrapper">
              <table class="rules-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th v-if="!hasRuleProdutos">Valor Mínimo</th>
                    <th v-if="hasRuleProdutos">Valor Mínimo do Pedido</th>
                    <th>Regra</th>
                    <th class="text-right">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(regra, index) in item.regras" :key="index">
                    <td class="td-index">{{ index + 1 }}</td>
                    <td>{{ toMonetary(regra.valorMinimo) }}</td>
                    <td>
                      {{ getDescricaoRegra(regra.dimensao, regra.tiporegra) }}
                    </td>
                    <td class="text-right">
                      <CButton
                        color="danger"
                        size="sm"
                        variant="ghost"
                        title="Remover"
                        @click="() => removeRule(regra, index)"
                      >
                        <fa-icon icon="trash-alt" />
                      </CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <cupomProdutos
              v-if="hasRuleProdutos"
              :item="item"
              :produtos="produtos"
            />
          </CTab>
          <CTab title="Clientes">
            <div class="row mb-3">
              <div class="col-12">
                <vue-dropzone
                  :useCustomSlot="true"
                  ref="dropzone"
                  id="dropzone"
                  v-on:vdropzone-success="uploadClientesdeArquivo"
                  v-on:vdropzone-removed-file="limpaClientesSelecionados"
                  :options="dropzoneOptions"
                >
                  <div class="dropzone-custom-content">
                    <h3 class="dropzone-custom-title">
                      Arraste e solte para importar de um arquivo!
                    </h3>
                    <div class="dropzone-custom-subtitle">
                      ...ou clique para selecionar um arquivo do seu computador
                    </div>
                  </div>
                </vue-dropzone>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <label class="field-label">Filtrar clientes</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filter"
                  v-on:input="debounceloadClientes()"
                  placeholder="Filtrar por id, cnpj ou razão social"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="lista-clientes" style="max-height: 500px; overflow-y: auto">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th colspan="3">
                          Clientes Disponíveis ({{ clientes.length }})
                          <CButton
                            size="sm"
                            color="success"
                            variant="ghost"
                            class="pull-right"
                            @click="addTodosClientes()"
                            title="Adicionar todos"
                          >
                            <fa-icon icon="plus" /> Adicionar todos
                          </CButton>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cliente in clientes" :class="{ 'cliente-disabled': clienteJaAdicionado(cliente.id) }">
                        <td>{{ cliente.id }}</td>
                        <td>
                          <small>{{ cliente.cnpj }}</small>
                          {{ cliente.razSoc }}
                        </td>
                        <td>
                          <CButton
                            size="sm"
                            color="success"
                            :disabled="clienteJaAdicionado(cliente.id)"
                            @click="addCliente(cliente)"
                          >
                            <fa-icon icon="plus" />
                          </CButton>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-6">
                <div class="lista-clientes" style="max-height: 500px; overflow-y: auto">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th colspan="3">
                          Clientes Vinculados ({{ item.clientes.length }})
                          <CButton
                            size="sm"
                            color="danger"
                            variant="ghost"
                            class="pull-right"
                            @click="remTodosClientes()"
                            title="Limpar todos"
                          >
                            <fa-icon icon="trash-alt" /> Limpar todos
                          </CButton>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cliente in item.clientes" :key="cliente.id">
                        <td class="highlight">{{ cliente.id }}</td>
                        <td class="highlight">
                          <small>{{ cliente.cnpj }}</small>
                          {{ cliente.razSoc }}
                        </td>
                        <td class="actions">
                          <CButton
                            size="sm"
                            color="danger"
                            variant="ghost"
                            @click="remCliente(cliente.id)"
                          >
                            <fa-icon icon="trash-alt" />
                          </CButton>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </CTab>
          <CTab title="Exclusões">
            <div>
              <Exclusoes :item="item" />
            </div>
          </CTab>
        </CTabs>
      </div>
    </div>

    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">
        Cancelar
      </CButton>
      <CButton color="primary" :disabled="validation.hasError()" @click="handleSubmit">
        Salvar Alterações
      </CButton>
    </div>
  </modal>
</template>

<style scoped>
/* ===== FIELD LABELS ===== */
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

/* ===== FORM SPACING ===== */
.form-group {
  margin-bottom: 6px;
}

.message:empty {
  display: none;
}

/* ===== SECTION LABEL ===== */
.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 12px 0 8px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.section-label .validation-error {
  color: #d92d20;
  font-weight: 500;
  text-transform: none;
  font-size: 12px;
}

/* ===== CANAIS GRID ===== */
.canais-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.canal-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;
}

.canal-card:hover {
  border-color: #c5c8cc;
  background-color: #fafafa;
}

.canal-card.active {
  border-color: #3a3e81;
  background-color: #eceaf3;
}

.canal-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #f2f2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #3a3e81;
  font-size: 16px;
}

.canal-card.active .canal-card__icon {
  background-color: #dddce9;
}

.canal-card__label {
  font-size: 13px;
  font-weight: 600;
  color: #2c2c2c;
  flex: 1;
}

.canal-card__check {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s ease;
}

.canal-card__check.checked {
  background-color: #3a3e81;
  border-color: #3a3e81;
  color: #fff;
}

/* ===== TOGGLES CARD ===== */
.toggles-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 4px 16px;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.toggle-row:last-child {
  border-bottom: none;
}

.toggle-row__label {
  font-size: 13px;
  color: #333;
}

.toggle-row__select,
.toggle-row__input {
  width: 200px !important;
  flex: 0 0 200px;
  text-align: right;
}

.toggle-row__validation {
  color: #d92d20;
  font-weight: 400;
  font-size: 11px;
  margin-left: 6px;
}

.toggle-row__money-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.toggle-row__money-group .toggle-row__input {
  width: 160px !important;
  flex: 0 0 160px;
}

/* ===== TOGGLE SWITCH ===== */
.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.toggle-switch input {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #3a3e81;
}

.toggle-switch input:checked + .toggle-slider::after {
  transform: translateX(16px);
}

.toggle-text {
  font-size: 12px;
  color: #777;
  min-width: 28px;
}

.toggle-inline {
  font-size: 12px;
  color: #667085;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* ===== NEW RULE CARD ===== */
.new-rule-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 16px;
  background: #f9fafb;
}

.new-rule-card .input-group {
  flex-wrap: nowrap;
}

.new-rule-card .input-group .form-control {
  height: 31px;
}

.new-rule-card .input-group .btn {
  height: 31px;
  display: inline-flex;
  align-items: center;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rule-alert {
  margin-top: 12px;
  margin-bottom: 0;
  font-size: 13px;
}

/* ===== RULES TABLE ===== */
.rules-table-wrapper {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 12px;
  margin-bottom: 12px;
}

.rules-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.rules-table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7eb;
}

.rules-table th {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 14px;
  white-space: nowrap;
}

.rules-table td {
  padding: 10px 14px;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.rules-table tr:last-child td {
  border-bottom: none;
}

.td-index {
  font-weight: 600;
  color: #3a3e81;
}

/* ===== DROPZONE ===== */
#dropzone {
  position: relative;
  border: 2px dashed #dddce9;
  border-radius: 10px;
  background: #f9fafb;
  min-height: 120px;
}

.dropzone-custom-content {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  color: #3a3e81;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px;
  background-color: initial;
}

.dropzone-custom-subtitle {
  color: #667085;
  font-size: 12px;
}

/* ===== CLIENT TABLES ===== */
.lista-clientes {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
}

.lista-clientes .table {
  margin-bottom: 0;
}

.lista-clientes .table thead th {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 14px;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.lista-clientes .table tbody td {
  padding: 8px 14px;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.lista-clientes .table tbody td.highlight {
  font-weight: 500;
  color: #3a3e81;
}

.lista-clientes .table tbody td.actions {
  text-align: right;
  white-space: nowrap;
}

.lista-clientes .table tbody tr.cliente-disabled {
  opacity: 0.45;
  pointer-events: none;
}

/* ===== MODAL FOOTER ===== */
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}

/* ===== FORM TWEAKS ===== */
.form-group {
  margin-bottom: 12px;
}

.form-group label:not(.field-label):not(.toggle-switch):not(.toggle-inline) {
  font-size: 13px;
}

.message {
  font-size: 12px;
  color: #d92d20;
  margin-top: 2px;
}
</style>

<script>
import Vue from "vue";

import setup from "../../config";
import SimpleVueValidation from "simple-vue-validator";
import _find from "lodash/find";
import _filter from "lodash/filter";
import _difference from "lodash/difference";
import _reject from "lodash/reject";
import _differenceBy from "lodash/differenceBy";
import _concat from "lodash/concat";
import _some from "lodash/some";
import { toMonetary, isNumeric } from "../../helpers/utils";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueNumeric from "vue-numeric";
import CloseModal from "../../components/CloseModal";
import cupomProdutos from "./components/Produtos";
import _isEmpty from "lodash/isEmpty";
import _debounce from "lodash/debounce";
import Exclusoes from "./components/Exclusoes";
import EmptyState from "../../components/EmptyState";
import { get, post, put, del } from "@/helpers/apiRequest";
import _map from "lodash/map";

Vue.component("Exclusoes", Exclusoes);

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "Campo de preenchimento obrigatório",
    greaterThan: "Valor deve ser maior que {0}",
    lessThan: "Valor deve ser menor que {0}",
  },
});

const dropzoneDictionary = {
  dictDefaultMessage:
    "Arraste um arquivo .xls(x) ou clique para importar clientes",
  dictFallbackMessage:
    "Seu navegador não suporta upload o recurso de arrastar e soltar",
  dictFileTooBig: "O arquivo excedeu o tamanho máximo permitido (5MB)",
  dictInvalidFileType: "Arquivo no formato inválido",
  dictResponseError: "Erro ao processar solicitação, tente novamente!",
  dictCancelUpload: "Cancelar",
  dictCancelUploadConfirmation: "Tem certeza?",
};

const initialRule = () => ({
  valorMinimo: 1,
  dimensao: {
    id: "1",
    coluna: 1,
    tiporegra: "D",
  },
});

const initialRuleForm = () => ({
  type: "D",
  dim: 0,
});

export default {
  name: "cupomEdit",
  props: [
    "item",
    "dimensoes",
    "produtos",
    "update",
    "close",
    "error",
    "descSingular",
  ],
  components: { Exclusoes },
  data() {
    return {
      newRule: initialRule(),
      newRuleForm: initialRuleForm(),
      hasRulePedido: false,
      hasRuleProdutos: false,
      hasRuleDimensoes: false,
      filter: "",
      resultLimit: 100,
      monetary: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        masked: false,
      },
      activeTab: "1",
      dropzoneOptions: {
        url: `${setup.api}/admin/cupons/importar-clientes`,
        acceptedFiles: ".xls, .xlsx",
        maxFilesize: 5,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        paramName: "clientes",
        ...dropzoneDictionary,
      },
      clientes: [],
      clientesAdicionados: [],
      isChecked: false,
    };
  },
  watch: {
    dimensoes: {
      immediate: true,
      handler(val) {
        if (!val || !val.length) return;
        if (this.newRuleForm.type !== "D") return;
        const grupo = val[this.newRuleForm.dim];
        if (!grupo || !grupo.dimensoes || !grupo.dimensoes.length) return;
        this.newRule.dimensao = {
          id: grupo.dimensoes[0].id,
          coluna: grupo.coluna,
        };
      },
    },
    "item.clientes": function () {
      this.item.validarCliente = this.item.clientes.length !== 0;
    },
    "item.produtos": function () {
      this.item.validarProduto = this.item.produtos.length !== 0;
    },
    "item.regras": function () {
      this.hasRuleDimensoes = true;
      this.hasRulePedido = true;
      this.hasRuleProdutos = true;

      // Confere se tem regra de dimensões
      var verifyDimensaoRegras = null;
      verifyDimensaoRegras = this.item.regras.find(
        (regras) => regras.tiporegra === "D"
      );

      if (verifyDimensaoRegras == "undefined" || verifyDimensaoRegras == null) {
        this.hasRuleDimensoes = false;
      }

      // Confere se tem regra de pedido
      var verifyPedidoRegras = null;
      verifyPedidoRegras = this.item.regras.find(
        (regras) => regras.tiporegra === "P"
      );

      if (verifyPedidoRegras == "undefined" || verifyPedidoRegras == null) {
        this.hasRulePedido = false;
      }

      // Confere se tem regra de produtos
      var verifyProdutosRegras = null;
      verifyProdutosRegras = this.item.regras.find(
        (regras) => regras.tiporegra === "PR"
      );

      if (verifyProdutosRegras == "undefined" || verifyProdutosRegras == null) {
        this.hasRuleProdutos = false;
      }
    },
  },
  computed: {
    getDimensoesItens() {
      if (this.dimensoes[this.newRuleForm.dim]) {
        return this.dimensoes[this.newRuleForm.dim].dimensoes;
      }
      return [];
    },
    isValorMinimoZero() {
      return this.newRule.valorMinimo == 0;
    },
  },
  validators: {
    "item.codigo": (value) => Validator.value(value).required(),
    "item.orientacao": (value) => Validator.value(value).required(),
    "item.valor": (value) => Validator.value(value).required().greaterThan(0),
    "item.ativo": (value) => Validator.value(value).required(),
    "item.clientes, item.validarCliente": (clientes, validarCliente) => {
      if (!!validarCliente) {
        return Validator.value(clientes).required();
      }
      return;
    },
    "item.produtos, item.validarProduto": (produtos, validarProduto) => {
      if (!!validarProduto) {
        return Validator.value(produtos).required();
      }
      return;
    },
    "item.dataInicio": (value) => Validator.value(value).required(),
    "item.dataFim": (value) => Validator.value(value).required(),
    "item.regras": (value) => Validator.value(value).required(),
    "item.limiteUsos": (value) =>
      Validator.value(value).required().greaterThan(0),
    "item.valor_maximo_permitido": (value) =>
      Validator.value(value).lessThan(1000000),
  },
  components: {
    vueDropzone: vue2Dropzone,
    VueNumeric,
    CloseModal,
    cupomProdutos,
    EmptyState,
  },
  methods: {
    beforeOpen() {
      this.loadClientes();
    },
    clientesDisponiveis() {
      return _differenceBy(this.clientes, this.item.clientes, "id");
    },
    addCliente(cliente) {
      this.item.clientes.push(cliente);
    },
    addTodosClientes() {
      let clientes = this.clientesDisponiveis();

      for (let cliente of clientes) {
        this.addCliente(cliente);
      }
    },
    clienteJaAdicionado(idCliente) {
      return _find(this.item.clientes, { id: idCliente });
    },
    clientesJaAdicionados() {
      let clientes = this.clientesDisponiveis();
      return clientes.length === 0;
    },
    remCliente(idCliente) {
      this.item.clientes = _reject(this.item.clientes, { id: idCliente });
    },
    remTodosClientes() {
      this.item.clientes = [];
    },
    loadClientes(take = 50) {
      get(`/admin/cupons-clientes?take=${take}&q=${this.filter}`)
        .then((json) => {
          this.clientes = json.itens;
          this.loading = false;
        })
        .catch((err) => (this.loading = false));
    },
    debounceloadClientes: _debounce(function () {
      this.loadClientes();
    }, 300),
    resetTipointegracao() {
      this.item.tipoIntegracao = null;
    },
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          const valorMaximo = this.isChecked
            ? this.item.valor_maximo_permitido
            : null;
          const item = this.item;
          item.valor_maximo_permitido = valorMaximo;
          this.update(item);
        }
      });
    },
    getDescricaoRegra(dimensao, tipoRegraDesc) {
      if (dimensao === null && tipoRegraDesc === "P") {
        return "Total do Pedido";
      }
      if (dimensao === null && tipoRegraDesc === "PR") {
        return "Regra de Produtos";
      }
      const grupo = _find(
        this.dimensoes,
        (g) => g.coluna === dimensao.coluna
      );
      if (!grupo) return "";
      const dimensaoDesc = _find(
        grupo.dimensoes,
        (dim) => String(dim.id) === String(dimensao.id)
      );
      if (!dimensaoDesc) return grupo.label;
      return grupo.label + " = " + dimensaoDesc.desc;
    },
    changeDimensao() {
      this.newRule.dimensao = {
        id: this.dimensoes[this.newRuleForm.dim].dimensoes[0].id,
        coluna: this.dimensoes[this.newRuleForm.dim].coluna,
      };
    },
    resetNewRule() {
      if (this.newRuleForm.type === "P" || this.newRuleForm.type === "PR") {
        this.newRule.dimensao = null;
      } else {
        this.changeDimensao();
      }
    },
    resetNewRuleForm() {
      this.newRuleForm = initialRuleForm();
      this.newRule = initialRule();
      if (this.dimensoes && this.dimensoes.length) {
        this.changeDimensao();
      }
    },
    addRule(tipo) {
      const rule = this.newRule;

      if (tipo === "P") {
        this.hasRulePedido = true;
      }
      if (tipo === "PR") {
        this.hasRuleProdutos = true;
      }
      if (tipo === "D") {
        this.hasRuleDimensoes = true;
      }

      rule.tiporegra = tipo;

      this.item.regras.push(rule);
      this.resetNewRuleForm();
    },
    removeRule(rule, i) {
      if (rule.tiporegra === "P") {
        this.hasRulePedido = false;
      }
      if (rule.tiporegra === "PR") {
        this.hasRuleProdutos = false;
      }

      this.item.regras.splice(i, 1);

      if (rule.tiporegra === "D") {
        var verifyDimensaoRegras = null;
        verifyDimensaoRegras = this.item.regras.find(
          (regras) => regras.dimensao !== null
        );

        if (
          verifyDimensaoRegras == "undefined" ||
          verifyDimensaoRegras == null
        ) {
          this.hasRuleDimensoes = false;
        }
      }
    },
    onRemoveCliente(id) {
      this.item.clientes = _filter(this.item.clientes, (idCliente) => {
        return +id !== +idCliente;
      });
    },
    changeTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab;
      }
    },
    uploadClientesdeArquivo(arquivo, resposta) {
      if (!resposta.clientes || !resposta.clientes.length) return;

      const idsExistentes = new Set(this.item.clientes.map(c => `${c.id}`));
      const novosClientes = resposta.clientes.filter(c => !idsExistentes.has(`${c.id}`));

      this.item.clientes = _concat(this.item.clientes, novosClientes);
    },
    limpaClientesSelecionados() {
      this.$refs.dropzone.removeAllFiles();
      this.item.clientes = [];
    },
    toMonetary,
  },
};
</script>
